import OneSignal from "react-onesignal";

export default async function runOneSignal(appId, initialized, setInitialized) {
  if (!initialized && appId) {
    await OneSignal.init({ appId: appId, allowLocalhostAsSecureOrigin: true}).then(() => {
      setInitialized(true);
    })
  }
}